/*
  IfShe collection / search page helpers — 2026-10-14 redesign (collection C1–C3).
  1. Intro "Read more": the full intro is always in the HTML; CSS clamps it to two lines,
     this only toggles .is-expanded + aria-expanded (and hides the button if the text already fits).
  2. Mobile sticky filter bar: Dawn's drawer is position:fixed inside the sticky aside, so the aside is
     lifted above the header while the drawer is open (CSS :has() does it too; this is the fallback).
  3. Sort quick-pick: the visible select in the bar mirrors the drawer's own sort select
     (#FacetFiltersFormMobile [name=sort_by]); a change is copied there and rendered through Dawn's
     facet-filters-form (same request Dawn makes), with a plain URL fallback.
  4. Related-category pills: scroll the current pill into view inside its row (no page scroll).
  No dependencies; safe to load twice.
*/
(() => {
  if (window.ifsheCollectionInit) return;
  window.ifsheCollectionInit = true;

  /* 1 · Read more */
  const initReadMore = () => {
    document.querySelectorAll('[data-ifshe-readmore]').forEach((box) => {
      if (box.dataset.ifsheReady) return;
      box.dataset.ifsheReady = '1';
      const btn = box.querySelector('.ifshe-coll-desc__toggle');
      const body = box.querySelector('.ifshe-coll-desc__body');
      if (!btn || !body) return;
      btn.addEventListener('click', () => {
        const open = !box.classList.contains('is-expanded');
        box.classList.toggle('is-expanded', open);
        btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
      /* short intro that already fits in two lines: no button (measure after web fonts settle) */
      const check = () => {
        if (!box.classList.contains('is-expanded') && body.scrollHeight <= body.clientHeight + 2) btn.hidden = true;
      };
      if (document.fonts && document.fonts.ready) document.fonts.ready.then(check);
      else check();
    });
  };

  /* 2 · Lift the sticky bar while its drawer is open (toggle does not bubble → capture) */
  document.addEventListener(
    'toggle',
    (event) => {
      const details = event.target;
      if (!(details instanceof HTMLDetailsElement) || !details.classList.contains('mobile-facets__disclosure')) return;
      const sticky = details.closest('.ifshe-facets-sticky');
      if (sticky) sticky.classList.toggle('is-drawer-open', details.open);
    },
    true
  );

  /* 3 · Sort quick-pick */
  const drawerSort = () => {
    const form = document.getElementById('FacetFiltersFormMobile');
    return form ? form.querySelector('select[name="sort_by"]') : null;
  };
  const syncProxy = () => {
    const proxy = document.querySelector('[data-ifshe-sort-proxy]');
    const source = drawerSort();
    if (!proxy || !source || proxy.value === source.value) return;
    proxy.value = source.value;
    const label = document.querySelector('[data-ifshe-sort-value]');
    const opt = proxy.options[proxy.selectedIndex];
    if (label && opt) label.textContent = opt.text.trim();
  };
  document.addEventListener('change', (event) => {
    const proxy = event.target.closest ? event.target.closest('[data-ifshe-sort-proxy]') : null;
    if (!proxy) return;
    const label = document.querySelector('[data-ifshe-sort-value]');
    const opt = proxy.options[proxy.selectedIndex];
    if (label && opt) label.textContent = opt.text.trim();

    const source = drawerSort();
    const FacetForm = window.customElements && customElements.get('facet-filters-form');
    if (source && FacetForm && typeof FacetForm.renderPage === 'function') {
      source.value = proxy.value;
      const form = source.form;
      FacetForm.renderPage(new URLSearchParams(new FormData(form)).toString());
      return;
    }
    if (source) {
      source.value = proxy.value;
      source.dispatchEvent(new Event('input', { bubbles: true }));
      return;
    }
    const url = new URL(window.location.href);
    url.searchParams.set('sort_by', proxy.value);
    url.searchParams.delete('page');
    window.location.assign(url.toString());
  });

  /* keep the quick-pick honest after Dawn re-renders (drawer sort changed, back/forward) */
  const watchGrid = () => {
    const grid = document.getElementById('ProductGridContainer');
    if (!grid || grid.dataset.ifsheWatch) return;
    grid.dataset.ifsheWatch = '1';
    new MutationObserver(syncProxy).observe(grid, { childList: true });
  };

  /* 4 · Related pills: bring the current one into view inside the row */
  const centerCurrentPill = () => {
    document.querySelectorAll('.ifshe-coll-related__list').forEach((list) => {
      const current = list.querySelector('[aria-current]');
      if (!current || list.scrollWidth <= list.clientWidth) return;
      const item = current.parentElement;
      const left = item.offsetLeft - (list.clientWidth - item.offsetWidth) / 2;
      list.scrollLeft = Math.max(0, left);
    });
  };

  const init = () => {
    initReadMore();
    watchGrid();
    syncProxy();
    centerCurrentPill();
  };
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  window.addEventListener('popstate', () => setTimeout(syncProxy, 400));
})();
